import { Component, OnInit, HostListener, ViewChild, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import _ from 'lodash';
import { Global } from 'src/app/global/globalApi';
import { ApiService } from 'src/app/services/api.service';
import { CustomerAccountBusinessLogicService } from 'src/app/services/customer-account-business-logic.service';
import { CustBusService } from 'src/app/services/customer-search-bussiness-logic.service';
import { NewAgentApiService } from 'src/app/services/new-agent-api.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from './../../../models/Constants';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CallCustomerAttributes } from 'src/app/models/customer.model';
export interface IMySelectOption {
  id: number;
  value: string;
  label: string;
}
@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss'],

})
export class AuthenticationComponent implements OnInit {
  @Output('onChangeCustomerTypeEmitter')
  onChangeCustomerTypeEmitter: EventEmitter<any> = new EventEmitter();
  @Output('goToApprovedExceptionPageEmitter')
  goToApprovedExceptionPageEmitter: EventEmitter<any> = new EventEmitter();
  @Output('goToCustomerOverviewPageEmitter')
  goToCustomerOverviewPageEmitter: EventEmitter<any> = new EventEmitter();
  errorMsg = Constants.CUSTOMER_TYPE_FAILURE_MSG;
  @Output('updateSecurityForAPEX') updateSecurityForAPEX: EventEmitter<any> = new EventEmitter();
  public authEgainConfig: any;
  public eGainConfig = Constants.AuthMenu;
  public fullySecured = Constants.FULLY_SECURED;
  //Pin Reset CCR6-566
  // This is a static value. Please remove once feature works on the same.
  deliveryOption: string | undefined;
  delivery_method: string[] = ['Email address', 'Postal address'];

  emailOption: string | undefined;
  email_method: string[] = ['a*******b@email.com (preferred)', 'b*******c@email.com'];

  postalOption: string | undefined;
  postal_address: string[] = ['2******3 N***h W*******s St, L*********n, Kentucky 12345 (preferred)', '1******2 S***h M*******n Av*, S*********d, Maine 12345', 'Set a temporary address'];

  tempOption1: string | undefined;
  temp_address1: string[] = ['2******3 N***h W*******s St, L*********n, Kentucky 12345 (preferred)'];

  tempOption2: string | undefined;
  temp_address2: string[] = ['1******2 S***h M*******n Av*, S*********d, Maine 12345'];

  // Display the dropdown for Bad Address
  // This is a static value. Please remove once feature works on the same.
  tempOptions = [
    { value: '1', viewValue: 'No action needed' },
    { value: '2', viewValue: 'Set Bad Address' }
  ];
  // One time code CCR6-572
  public selectedValue?: IMySelectOption;
  public options: IMySelectOption[] = [
    {
      id: 1,
      value: 'value1',
      label: 'Email',
    },
    {
      id: 2,
      value: 'value2',
      label: 'Text',
    },
  ];

  public emailoptions: IMySelectOption[] = [
    {
      id: 1,
      value: 'value1',
      label: 'a*******b@email.com (preferred)',
    },
    {
      id: 2,
      value: 'value2',
      label: 'b*******c@email.com',
    },
  ];

  public textoptions: IMySelectOption[] = [
    {
      id: 1,
      value: 'value1',
      label: '********542',
    },
    {
      id: 2,
      value: 'value2',
      label: '********319',
    },
  ];
  // Below code to be used and to be removed from multiple places once all the dropdowns are made common.

  @ViewChild(MatSelect) select!: MatSelect;
  @HostListener('window:scroll', [])
  /* istanbul ignore next */
  onScroll(): void {
    if (this.select?.panelOpen) {
      this.select.close();
    }
  }
  panelOpenState = false;
  showContent: boolean = true;
  methodInstruction: boolean = true;
  errorMessage: String = ''; infoMessage: String = '';
  indicativeDataApiFailure = Constants.AUTHENTICATION_COMPONENT_ERR_MSG.API_FAILURE_INDICATIVEDATA;
  indicativeDataConfigMiss = Constants.AUTHENTICATION_COMPONENT_ERR_MSG.CONFIG_MISS_INDICATIVEDATA;
  indicativeDataValueMiss = Constants.AUTHENTICATION_COMPONENT_ERR_MSG.VALUE_MISS_INDICATIVEDATA;
  maxDate = new Date();
  validationSuccessMessage = Constants.indicativeMessages.validationSuccessMessage;
  constructor(
    public rootScope: RootScopeService,
    public apiService: ApiService,
    public newAgentapiService: NewAgentApiService,
    public cusAccService: CustomerAccountBusinessLogicService,
    public cusSearchService: CustBusService,
    public fb: FormBuilder,
    private http: HttpClient
  ) { }
  validationFailureErrorMessage = Constants.indicativeMessages.validationFailureMessage;
  dateOfBirth = new FormControl('', [Validators.required]);
  oneTimeCode = new FormControl('', [Validators.required])
  ngOnInit(): void {
    if (!this.rootScope.activeCustTab?.authenticationEgainContent?.authenticationConfig) {
      this.getAuthenticationConfig();
    }
    this.cusSearchService.getAuthenticationMethods(this.rootScope.activeCustTab?.clientId, this.rootScope.activeCustTab?.customerType);
  }


  /**
   * Page load time GetAuthenticationConfig for each menu content id and call overView Egain content
   * 
   */
  getAuthenticationConfig() {
    this.newAgentapiService.getApi(Global.authenticationApis.gethenticationContentList, { clientId: this.rootScope.activeCustTab.clientId }, 'false', true)
      .subscribe({
        next: (res) => {
          if (this.newAgentapiService.errorValidation(res)) {
            this.rootScope.activeCustTab.authenticationEgainContent.authenticationConfig = res.data;
            this.authEgainConfig = res.data;
            this.getEgainContent(res.data.find(x => x["securityMethodCode"] == this.eGainConfig.OverView)?.contentId, true);
          } else {
            this.rootScope.enableAlerts(Constants.ERROR, res.message);
          }
        },
        error: (error) => {
          this.rootScope.logMessage(Constants.ERROR, Constants.AlertMsg.error500);
        }
      })
  }
  /**
   * 
   * @param ContentId need to pass in api reques to capurting eGain  Content
   * @param overView to capurting eGain  Content for over view or authenticationEgainContent
   * 
   */
  /* istanbul ignore next */
  getEgainContent(ContentId, overView?) {
    this.newAgentapiService.postApi(Global.authenticationApis.fetchEgainContent, { contentId: ContentId }, 'false', Constants.apiVersions, true)
      .subscribe({
        next: (res) => {
          if (this.newAgentapiService.errorValidation(res)) {
            if (overView) { this.rootScope.activeCustTab.authenticationEgainContent.overViewHtml = JSON.parse(res.data); this.rootScope.activeCustTab.authenticationEgainContent.overViewError = ''; }
            else { this.rootScope.activeCustTab.authenticationEgainContent.authenticationHtml = JSON.parse(res.data); this.rootScope.activeCustTab.authenticationEgainContent.authEgainError = ''; }
          } else {
            this.updateError(overView);
          }

        },
        error: (error) => {
          this.updateError(overView);
          this.rootScope.logMessage(Constants.ERROR, Constants.AlertMsg.error500);
        }
      })
  }

  updateError(overView) {
    if (overView) {
      this.rootScope.activeCustTab.authenticationEgainContent.overViewError = Constants.eGainError[301];
      this.rootScope.activeCustTab.authenticationEgainContent.overViewHtml = { name: '', content: '' };

    } else {
      this.rootScope.activeCustTab.authenticationEgainContent.authEgainError = Constants.eGainError[301];
      this.rootScope.activeCustTab.authenticationEgainContent.authenticationHtml = { name: '', content: '' };;
    }
    this.rootScope.logMessage(Constants.ERROR, Constants.eGainError[301]);
  }

  @HostListener('window:resize', []) resize() {
    if (window.innerWidth >= 1200) {
      this.showContent = true;
      this.methodInstruction = true;
    }
  }
  getErrorMessage() {
    if (this.dateOfBirth.hasError('required')) {
      return 'Date of Birth must be in the MM/DD/YYYY format.';
    }

    return this.dateOfBirth.hasError('dateOfBirth')
      ? 'Incorrect Date of Birth'
      : '';
  }

  eGainUpdate(Type) {

    if (!this.rootScope.activeCustTab?.authenticationEgainContent?.authenticationHtml 
      || this.rootScope.activeCustTab?.authenticationEgainContent?.authenticationHtml?.content == ''
      || Type != this.rootScope.activeCustTab?.authenticationEgainContent?.authenticationType) {
      this.rootScope.activeCustTab.authenticationEgainContent.authenticationType = Type;
      this.getEgainContent(this.rootScope.activeCustTab.authenticationEgainContent?.authenticationConfig?.find(x => x['securityMethodCode'] == Type)?.contentId);

    }
  }

  /**
   * 
   * @param Type Selected menu securityMethodCode Type in authentication page
   * To maintain same state when user change from one account other account 
   * @returns boolean value 
   */
  menuExpansionType(Type) {
    return (this.rootScope.activeCustTab?.authenticationEgainContent && this.rootScope.activeCustTab.authenticationEgainContent.authenticationType == Type)
  }

  changeCustomerType(event: any) {
    this.onChangeCustomerTypeEmitter.emit(event);
  }


  /** This method emits a value when a click event occurs on the Go to Approved Exception Page link, 
   *which is used within the Customer Account component. */
  goToApprovedExceptionPage() {
    let obj: any = {};
    this.goToApprovedExceptionPageEmitter.emit(obj);
  }

  /**
 * Retrieves error messages for the Date of Birth field in the indicativeDataForm.
 * @returns Error message based on the validation status of the Date of Birth control.
 */
  getIndicativeDataDobErrorMessages() {
    const dateOfBirthControl = this.cusAccService.indicativeDataForm.get('Date of Birth');
    if (dateOfBirthControl?.hasError('required')) {
      return 'Date of Birth must be in the MM/DD/YYYY format.';
    }
    else if (dateOfBirthControl?.hasError('matDatepickerMax')) {
      return 'Date of Birth cannot be a future date.';
    }
    return '';
  }


  /**
   * Handles the form submission for the indicative data form.
   * Logs form values if the form is valid; otherwise, logs an error message.
   */
  onSubmit() {
    if (this.cusAccService.indicativeDataForm.valid) {
      const formValue = this.cusAccService.indicativeDataForm.value;
      console.log('Form submitted with values:', formValue);

      const keyTitleArray = this.rootScope.activeCustTab.authenticationIndicativeData.keyTitleMapping;
      const validatePayload = {};
      Object.keys(formValue).forEach(key => {

        const authenticationData = _.find(keyTitleArray, (x) => {
          return x?.key == key;
        });
        const title = authenticationData?.title;
        const value = formValue[key];

        if (title) {
          if (title?.includes('DOB'))
            validatePayload[title] = this.formatDate(value);
          else
            validatePayload[title] = value;
        }

        console.log('ValidateIND payload' + validatePayload);

      });
      if (validatePayload) {
        this.validateIndicativeData(validatePayload);
      }

    } else {
      console.log('Form is not valid. Please correct errors.');
    }
  }

  /**
 * @Author Arun Jaiswal
 * @param validatePayload 
 * Mehtod used  for validation API . This API is used to validate 
 * Indicative data credentionals on Authentication Tab.
 */
  /* istanbul ignore next */
  validateIndicativeData(validatePayload) {
    this.rootScope.activeCustTab.authenticationIndicativeData.validationFailure = false;
    this.rootScope.activeCustTab.authenticationIndicativeData.validationSuccess = false;
    this.validateIndicativeDataObs(validatePayload).subscribe({
      next: (res) => {
        if (res && res?.data?.length > 0 && res?.data?.includes('Success')) {

          this.rootScope.activeCustTab.genesysAttributes.CS_AUTH_CD = Constants.AuthMethods['IND-DATA'];
          this.rootScope.logMessage(Constants.INFO, 'getAuthenticationContentList successfully called for clientId:');
          this.rootScope.activeCustTab.authenticationIndicativeData.validationSuccess = true;
          if (this.rootScope.activeCustTab.authenticationIndicativeData.validationSuccess) {
            let model = { CS_SECURITY_LEVEL: Constants.securityLevels.SL4, authenticateStatus: Constants.FULLY_SECURED, iconClass: 'green', CP_INDICATIVE_DATA_SECURED: true, domain: this.goToCustomerOverviewPageEmitter }
            let body: CallCustomerAttributes = {
              attributes: {
                CP_INDICATIVE_DATA_SECURED: true,
                CS_AUTH_CD: Constants.AuthCode['IND-DATA']
              },
            };
            this.rootScope.activeCustTab.genesysAttributes.CP_INDICATIVE_DATA_SECURED = true;
            this.rootScope.activeCustTab.iconClass = 'green';
            this.apiService.setAccountSecurityDt(model, body);
          }
          //this.goToCusOveriew();
        }
        else {
          this.rootScope.activeCustTab.authenticationContents.authenticationConfigMiss = true;
          this.rootScope.activeCustTab.authenticationIndicativeData.validationFailure = true;

        }
      },
      error: (error) => {
        this.rootScope.activeCustTab.authenticationIndicativeData.validationFailure = true;
        this.rootScope.logMessage(Constants.ERROR, 'updateCustomerInElasticCache Error while updating data in EC for CustomerSessionId: ' + this.rootScope.activeCustTab.customerSessionId);
      }
    })
  }

  /**
   * 
   * @param validatePayload 
   * @returns obserable to be subscribed for validation API . This API is used to validate 
   * Indicative data credentionals on Authentication Tab.
   */
  validateIndicativeDataObs(validatePayload): Observable<any> {
    return this.http.post(Global.domainUrl + Global.authenticationApis.validateIndicativeData, validatePayload, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),

    });
  }

  /**
   * Method to trigger emmitter of customer-account component to go to customer over view Page. 
   */
  goToCusOveriew() {
    let obj: any;
    this.goToCustomerOverviewPageEmitter.emit(obj);
  }

  /**
   * @author Arun 
   * @param date 
   * @returns date in MMM-DD-YYYY format . Used to convert date in specific format as per backend API for validation
   */
  formatDate(date: string): string {
    // Convert string to Date object
    const formattedDate = new Date(date);
    // Format the date using toLocaleDateString method
    const month = formattedDate.toLocaleString('en-us', { month: 'short' });
    const day = formattedDate.getDate()?.toString()?.padStart(2, '0');
    const year = formattedDate.getFullYear();
    // Format the date string as "Oct-10-1978"
    return `${month}-${day}-${year}`;
  }


  /**
   * Resets enabled form controls to their initial values on form cancellation.
   */
  onCancelIndicativeData() {
    // Iterate through form controls
    this.rootScope.activeCustTab.authenticationIndicativeData.validationFailure = false;
    this.rootScope.activeCustTab.authenticationIndicativeData['indicativeDataAPIConfigMiss'] = false;
    this.rootScope.activeCustTab.authenticationIndicativeData['indicativeDataValueMiss'] = false;
    this.rootScope.activeCustTab.authenticationIndicativeData['indicativeDataAPIFailure'] = false;

    this.resetIndicativeDataCreds();
  }

  resetIndicativeDataCreds() {
    Object.keys(this.cusAccService.indicativeDataForm.controls).forEach(key => {
      const control = this.cusAccService.indicativeDataForm.get(key);
      // Check if the control is enabled
      if (control?.enabled) {
        control.reset();  // Reset only enabled controls
        control.markAsUntouched();
        control.markAsPristine();

      }
    });
  }


  isAuthenticationMethodVisible(securityCode) {
    const selectedAuthenticationContent = this.rootScope.activeCustTab.authenticationContents?.selectedAuthenticationContent;

    const authenticationData = _.find(selectedAuthenticationContent, (x) => {
      return x?.securityMethodCode == securityCode;
    });
    //  const authenticationData = selectedAuthenticationContent.find(x => x?.securityMethodCode == securityCode);

    if (authenticationData) {
      return true;
    }
    else {
      return false;
    }
  }

  tryAgainAuthenticationAPI() {
    this.cusSearchService.getAuthenticationMethods(this.rootScope.activeCustTab?.clientId, this.rootScope.activeCustTab.customerType);
  }

  /**
   * Checks if there are any indicative data errors and sets the appropriate error message.
   * @returns {boolean} True if there are indicative data errors, false otherwise.
   */
  showIndicativeDataErr(): boolean {
    if (this.infoMessage) return false;

    else if (this.rootScope.activeCustTab.authenticationIndicativeData.indicativeDataAPIConfigMiss) {
      this.errorMessage = this.indicativeDataConfigMiss;
      return true;
    }

    else if (this.rootScope.activeCustTab.authenticationIndicativeData.indicativeDataValueMiss) {
      this.errorMessage = this.indicativeDataValueMiss;
      return true;
    }

    else if (this.rootScope.activeCustTab.authenticationIndicativeData.indicativeDataAPIFailure) {
      this.errorMessage = this.indicativeDataApiFailure;
      return true;
    }

    else return false;
  }
  /**
   * @author Vamsi
   * the validate button when user choose indicative method in authentication process
   * @returns true or false for enable or disable the button
   */
  indicativeValidation() {
    return (!this.rootScope.activeCustTab.activeCall || !this.cusAccService.indicativeDataForm.valid || (this.cusAccService.indicativeDataForm.get('additionalCheckboxKey')?.value !== true) || (this.rootScope.activeCustTab.authenticationIndicativeData.indicativeDataValueMiss))
  }

  /**
 * @author Vamsi
 * Research account indicative methods need to disaply info message 
 * @returns true or false for show or hide info message 
 */
  infoWarning() {
    if (this.rootScope.activeCustTab?.channel == Constants.conversion.research || !(this.rootScope.activeCustTab?.activeCall || this.rootScope.activeCustTab?.activeChat)) {
      this.infoMessage = Constants.AUTH_IND_ERR;
      return true;
    }
    else if ((this.rootScope.activeCustTab?.activeCall && this.rootScope.activeCustTab?.CS_SECURITY_LEVEL == Constants.securityLevels.SL4) || this.rootScope.activeCustTab?.activeChat) {
      this.infoMessage = Constants.AUTH_IND_FULLY_SECURED;
      return true;
    } else {
      this.infoMessage = ''; return false;
    }
  }
}
